module.exports = __webpack_public_path__ + "h5/img/close.02ad081c.gif";